import React from 'react';
import { RefHandler } from 'react-popper';

import { OddStub } from 'components';
import type { OddButtonProps } from 'types';
import OddButtonContainer from './OddButtonContainer';

type Btn = React.DOMAttributes<HTMLButtonElement>;

interface Props extends OddButtonProps {
    withTitle?: boolean;
    onMouseEnter?: Btn['onMouseLeave'];
    onMouseLeave?: Btn['onMouseEnter'];
    stubNode?: JSX.Element;
    fRef?: RefHandler;
    modifyOddTitle?: (name: string) => string;
}

const OddButton: React.FC<Props> = ({
    oddId,
    showResult,
    withTitle,
    stubNode,
    modifyOddTitle,
}) => {
    return oddId ? (
        <OddButtonContainer
            oddId={oddId}
            showResult={showResult}
            withTitle={withTitle}
            modifyOddTitle={modifyOddTitle}
        />
    ) : (
        <OddStub stubNode={stubNode} />
    );
};

export default OddButton;
